{
  "list": {
    "title": "ஸ்மார்ட் சொற்றொடர்கள்",
    "backToDashboard": "டாஷ்போர்டு",
    "newButton": "புதிய சொற்றொடர்",
    "import": "இறக்குமதி",
    "export": "ஏற்றுமதி",
    "searchPlaceholder": "திறவுகோல் அல்லது விரிவாக்க உரை மூலம் தேடவும்...",
    "filterAllCategories": "அனைத்து வகைகள்",
    "header": "சொற்றொடர்கள் ({{count}})",
    "loading": "சொற்றொடர்கள் ஏற்றப்படுகின்றன...",
    "empty": "சொற்றொடர்கள் இல்லை. உங்கள் முதல் ஸ்மார்ட் சொற்றொடரை உருவாக்கவும்.",
    "authoredBy": "{{name}} இலிருந்து",
    "tooltips": {
      "preview": "முன்னோட்டம்",
      "edit": "திருத்து",
      "delete": "நீக்கு"
    },
    "confirmDelete": "உறுதிப்படுத்து",
    "cancelDelete": "ரத்துசெய்",
    "previewLabel": "முன்னோட்டம்:",
    "closePreview": "முன்னோட்டத்தை மூடு",
    "toast": {
      "deleted": "சொற்றொடர் நீக்கப்பட்டது",
      "importComingSoon": "இறக்குமதி வசதி விரைவில்",
      "exportComingSoon": "ஏற்றுமதி வசதி விரைவில்"
    }
  },
  "form": {
    "editTitle": "ஸ்மார்ட் சொற்றொடரை திருத்து",
    "createTitle": "புதிய ஸ்மார்ட் சொற்றொடர்",
    "fields": {
      "key": "திறவுகோல்",
      "category": "வகை",
      "expansionText": "விரிவாக்க உரை"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "\".\" உடன் தொடங்க வேண்டும்",
    "categoryUncategorized": "வகைப்படுத்தப்படாதது",
    "expansionPlaceholder": "குறுக்குவழியை மாற்றும் உரை...",
    "cancel": "ரத்துசெய்",
    "create": "சொற்றொடரை உருவாக்கு",
    "update": "சொற்றொடரை புதுப்பி",
    "toast": {
      "created": "சொற்றொடர் உருவாக்கப்பட்டது",
      "updated": "சொற்றொடர் புதுப்பிக்கப்பட்டது",
      "saveFailed": "சொற்றொடரை சேமிப்பதில் தோல்வி",
      "keyMustStartWithDot": "திறவுகோல் \".\" உடன் தொடங்க வேண்டும்",
      "keyTooShort": "திறவுகோல் குறைந்தது 2 எழுத்துகள் வேண்டும்",
      "expansionRequired": "விரிவாக்க உரை தேவை"
    }
  },
  "category": {
    "general": "பொது",
    "physicalExam": "உடல் பரிசோதனை",
    "reviewOfSystems": "அமைப்பு மீளாய்வு",
    "assessment": "மதிப்பீடு",
    "plan": "திட்டம்",
    "instructions": "வழிமுறைகள்",
    "medications": "மருந்துகள்",
    "history": "வரலாறு"
  }
}
